module.exports = __webpack_public_path__ + "style/img/DI_icon_Service .7b7be47c.png";